<co-panel [config]="panelConfig">
  <div class="flex flex-row w-full mt-5">
    <p-datepicker
      [(ngModel)]="rangeDates"
      selectionMode="range"
      [placeholder]="'FILTERS.DATE_RANGE' | translate"
      showIcon
      [readonlyInput]="true"
    />
  </div>
  <div class="flex flex-row w-full justify-end gap-1">
    <!-- Action Buttons: Reset and Apply -->
    <button pButton [severity]="'secondary'" (click)="resetRows()">
      {{"FILTERS.RESET" | translate}}
    </button>
    <button pButton [severity]="'success'" (click)="apply()">{{"FILTERS.APPLY" | translate}}</button>
  </div>
</co-panel>
